/* GM Vault — v3 Scroll Reveal
   Minimal, no-framework. Deferred. Each section handles its own JS inline.
*/
(function () {
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.gm-reveal').forEach(function (el) {
      io.observe(el);
    });
  } else {
    document.querySelectorAll('.gm-reveal').forEach(function (el) {
      el.classList.add('in');
    });
  }
})();
